import React, { useRef } from "react";
import { Grid, Typography, Card, Box } from "@mui/material";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import EqualizerOutlinedIcon from "@mui/icons-material/EqualizerOutlined";
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';

const features = [
  {
    icon: <img src="/images/brain.png" alt="brain" height="42px" />,
    title: "Easy to Use",
    desc: "Designed to be simpler than native AWS tools, our platform eliminates complexity with a clean interface and guided workflows — making cloud optimization easy for any team.",
  },
  {
    icon: <FaceRetouchingNaturalIcon sx={{ fontSize: "2.5rem", color: "#fff" }} />,
    title: "AI-Powered Optimization",
    desc: "Revolutionary machine learning algorithms continuously analyze your infrastructure and identify cost-saving opportunities in real-time with precision.",
  },
  {
    icon: <VerifiedUserIcon sx={{ fontSize: "2.5rem", color: "#fff" }} />,
    title: "Smart optimization with spot",
    desc: "Maximize savings with intelligent spot instance automation that shifts eligible workloads, monitors stability, and delivers spot pricing benefits without the hassle"
  },
  {
    icon: <EqualizerOutlinedIcon sx={{ fontSize: "2.5rem", color: "#fff" }} />,
    title: "Advanced Analytics",
    desc: "Comprehensive dashboards with detailed insights, forecasting, and recommendations to maximize your cloud ROI.",
  },
];

export default function Features() {
    const containerRef = useRef(null);

    const getCardStyle = (index) => ({
    transform: `scale(${1 + index * 0.02})`,
    transition: "transform 0.5s, opacity 0.2s",
    backgroundColor: "#ffffff",
    opacity: 3,
  });

      return (
    <Box
      // ref={containerRef}
      sx={{
        height: "85vh",
        top:0,
        mt: 7,
        overflowY: "scroll",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        background: "linear-gradient(to bottom,rgb(255, 255, 255) 10%,rgb(227, 228, 252) 60%,rgb(227, 227, 255) 10%, #ffffff 100%)",
      }}
    >
      <Grid
        item
        sx={{
          width:{lg:'70%', xs:'90%'},
          pt: {lg:4 , xs:1},
          pl: {lg:13 , xs:5},
          position: "sticky",
          top: 0,
       
        }}
      >
        <Grid
          item
        >
          <Typography  variant="h3" sx={{ fontWeight: "bold", mb: 2, color: "primary.main" }}>
          Revolutionary Features
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            fontSize: "1.2em",
            color: "rgb(116, 115, 115)",
          }}
        >
          Experience the future of cloud optimization with our cutting-edge
          platform
        </Grid>
      </Grid>
      <Box
      ref={containerRef}
        sx={{
          height: `${features.length * 80}vh`,
          position: "relative",
        }}
      >
        {features.map((card, index) => (
          <Grid
            container
            direction="row"
            key={index}
            sx={{
              position: "sticky",
              top: `${index * 20}px`,
              zIndex: index,
              height: {lg:"70vh",xs:"75vh"},
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Card
              elevation={6}
              sx={{
                width: {lg:"72%" , xs:"90%"},
                height: "38%",
                borderRadius: 2,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  filter: "brightness(1.1)",
                  transform: `scale(${1 + index * 0.03})`,
                  boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.3)",
                  cursor: "pointer",
                },
                backgroundColor:
                  "linear-gradient(90deg, rgb(132, 191, 242) 18%, rgb(18, 35, 97) 100%, rgb(228, 224, 224))",
                ...getCardStyle(index),
              }}
            >
              <Box
                sx={{
                  //   bgcolor: "rgb(220, 217, 217)",
                  boxShadow: "0px 12px 24px rgba(0, 0, 0, 0.3)",
                  borderRadius: "25%",
                  height: {lg:75 , xs:55},
                  width: {lg:75 , xs:55},
                  textAlign: "center",
                  alignItems: "center",
                  alignContent: "center",
                  background: "linear-gradient(135deg, #6E73F2 0%, #9C4DF4 100%)",
                  mb: 3,
                }}
              >
                {card.icon}
              </Box>
              <Box sx={{ width:{lg:"50vw" , xs:"60vw"} , px:{lg:4 , xs:2}}}>
                <Typography variant='h6' 
                // sx={{fontFamily:'"Inter", sans-serif',fontWeight:"bold", mt:1, fontSize:{lg:"1.7em" , xs:"1.3em"}}}
                >
                  {card.title}
                </Typography>
                <Typography
                variant='body2'
                  color="rgb(71, 71, 71)"
                  mt={2}
                  lineHeight="1.6em"
                >
                  {card.desc}
                </Typography>
              </Box>
            </Card>
          </Grid>
        ))}
      </Box>
    </Box>
  );
  
}
